module.exports = __webpack_public_path__ + "img/analyt-icon2.24e421af.svg";